var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _circle3, _circle4, _circle5, _path6, _path7, _circle6, _path8, _circle7, _circle8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7aece;}.cls-12,.cls-2,.cls-6,.cls-9{fill:#ffffff;}.cls-2{opacity:0.3;}.cls-3{fill:#8f5653;}.cls-4{fill:#4bc190;}.cls-5{fill:#f8dc25;}.cls-5,.cls-6{opacity:0.5;}.cls-7{fill:#515570;}.cls-8{fill:#393c54;}.cls-10{fill:none;stroke:#515570;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-10,.cls-12{opacity:0.2;}.cls-11{fill:#f85565;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.08,80.5l-.88-2.69c-2.89-7.83-17.3-46.91-17.78-48l-.5-1.29H90.8a30,30,0,0,0-53.6,0h-.13l-.52,1.36C35.51,32.44,19.07,77.1,19,77.42a47.49,47.49,0,0,0-1.54,24.39,60,60,0,0,0,93.16,0,49.66,49.66,0,0,0-.5-21.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.45,108.21a60,60,0,0,0,81.1,0,43.38,43.38,0,0,0,.84-29.09l-.14-.46c-4.87-13.2-16.91-45.81-17.49-47.22l-.05-.1a26,26,0,0,0-47.42,0l0,.08c-.57,1.38-16.82,45.28-17.5,47.26a43.4,43.4,0,0,0,.7,29.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.57,80.59C93.23,63.4,83,35.81,82.23,33.78a20,20,0,0,0-36.46,0C44.63,36.72,29.1,78.67,28.44,80.59a37.42,37.42,0,0,0,7,36.2,60.05,60.05,0,0,0,57.06,0A37.41,37.41,0,0,0,99.66,80.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.57,80.59C93.23,63.4,83,35.81,82.23,33.78a20,20,0,0,0-36.46,0C44.63,36.72,29.1,78.67,28.44,80.59a37.42,37.42,0,0,0,7,36.2,60.05,60.05,0,0,0,57.06,0A37.41,37.41,0,0,0,99.66,80.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64,122A29.49,29.49,0,0,1,36,83.13c.67-1.93,15.5-42,17.11-46.24a12,12,0,0,1,21.72,0c1.07,2.79,9.4,25.32,17.13,46.26l0,.12A29.49,29.49,0,0,1,64,122Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 64,
    cy: 92.5,
    r: 20.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 64,
    cy: 92.5,
    r: 11
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 79.66,
    cy: 56.5,
    r: 7.49
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M48.34,68a11.46,11.46,0,0,1-9.1-4.48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.84,68a11.52,11.52,0,0,0,9.85-5.56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 48.34,
    cy: 56.5,
    r: 7.49
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64,113A20.49,20.49,0,0,0,84.13,96.3,22.3,22.3,0,0,0,72,93.17c-.54,0-1.08,0-1.63.11A2.07,2.07,0,0,0,68.63,95a1.2,1.2,0,0,1-1.81.67A3.12,3.12,0,0,0,63.87,95a22.58,22.58,0,0,0-12.49,13.66A20.36,20.36,0,0,0,64,113Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 79.66,
    cy: 56.5,
    r: 4.09
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 48.34,
    cy: 56.5,
    r: 4.09
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.29,95.5a1.16,1.16,0,0,1-1.47.13,4.87,4.87,0,0,0-.59-.36c.43,3.56,1.66,9.24,5.21,13.08a1,1,0,0,0,.73.32,1,1,0,0,0,.68-.27,1,1,0,0,0,.06-1.41C69.91,103.75,68.74,98.81,68.29,95.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.68,59.51,60,64.28A2,2,0,0,0,61.93,67h4.19a2,2,0,0,0,1.93-2.72l-1.67-4.77A2.49,2.49,0,0,0,61.68,59.51Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.68,59.51,60,64.28A2,2,0,0,0,61.93,67h4.19a2,2,0,0,0,1.93-2.72l-1.67-4.77A2.49,2.49,0,0,0,61.68,59.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.6713b60278c692ab9ca054048a30091b.svg";
export { ForwardRef as ReactComponent };